module.exports = __webpack_public_path__ + "static/logo-4f9d71ad9c58103493bc8dd8e08ce2a7.png";